import React from 'react';
import styled from 'styled-components';
import { menuData } from '../data/MenuData';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa'

const DropdownContainer = styled.div`
    position: absolute; 
    z-index: 999;
    width: 100%; 
    height: 100%;
    background: #cd853f;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    right: 0;
    transition: 0.3s ease-in-out;
    opacity: ${({isOpen}) => (isOpen ? '1' : '0')};
    top: ${({isOpen}) => (isOpen ? '0' : '-100%')};
`

const Icon = styled.div`
    position: absolute;
    top: 2rem;
    right: 2rem;
    background: transparent;
    font-size: 2rem;
    cursor: pointer;
    outline: none;
`;

const CloseIcon = styled(FaTimes)`
    color: #000d1a;
`;

const DropdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
`;

const DropdownMenu = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 80px); 
    text-align: center;
    justify-content: center;
    align-items: center;
    margin-bottom: 4rem;
    margin-right: 0rem;

    @media screen and (max-width: 480px) {
        grid-template-rows: repeat(4, 60px)
    }
`;

const DropdownLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fff;
    font-size: 1.5rem;
    text-decoration: none; 
    list-style: none;
    color: #fff;
    cursor: pointer;
    transition: 0.2s ease-in-out;
    text-align: center;

    &:hover{
        color: #000d1a;
    }
`;

const BtnWrap = styled.div`
    display: flex; 
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    margin: 0 auto;
    padding: 0;
`;

const CustomButton = styled(Button)`
    background-color: rgba(237, 167, 29, 0.897) !important;
    border: 2px solid #fff !important;
    color: #fff !important;
    margin: 0 auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    width: auto !important;
    padding: 12px 24px !important;
    white-space: nowrap !important;
    
    &:hover {
        background-color: #fff !important;
        color: rgba(237, 167, 29, 0.897) !important;
        border: 2px solid rgba(237, 167, 29, 0.897) !important;
    }
`;

const Dropdown = ({isOpen, toggle}) => {
    return (
        <DropdownContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>

            <DropdownWrapper>
                <DropdownMenu>
                    {menuData.map((item, index) => (
                        <DropdownLink to={item.link} key={index}>
                            {item.title}
                        </DropdownLink>
                    ))}
                </DropdownMenu>
                <BtnWrap>
                    <CustomButton round="true" big="true" to="/signup">
                    Newsletter 
                    </CustomButton>
                </BtnWrap>
            </DropdownWrapper>
        </DropdownContainer>
    )
}

export default Dropdown